export default __webpack_public_path__ + "static/media/calconvert_m2.88151972.png";